var app = angular.module('leonardo');

var LabelDirective = function (ConfigThemeService, $timeout) {
  return {
    restrict: 'EC',
    scope: {
      requiredColor: '@',
      ngClass: '=?'
    },
    link: function (scope, element) {

      scope.getNgClass = function() {
        if (isEmpty(scope.ngClass)) {
          return '';
        }
        else {
          var classes = '';
          angular.forEach(scope.ngClass, function (value, key) {
            if (value){
              classes += ' ' + key;
            }
          });
          return classes;
        }
      };

      scope.$watch(
        function () {
          return element.attr('class') + scope.getNgClass();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        $timeout(function () {
          var color = scope.requiredColor ? ConfigThemeService.getColor(scope.requiredColor) : ConfigThemeService.config.theme_config.errorColor;
          scope.classes = element.attr('class');
          if (scope.classes.includes('required')){
            if (element.find('.after').length === 0){
              var after = angular.element( "<span class='after'>*</span>" );
              after.css('color', color);
              element.append( after );
            }
          }
          else if (element.find('.after').length > 0){
            element.find('.after').remove();
          }
        });
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('label', ['ConfigThemeService', '$timeout', LabelDirective]);
